import cx from 'classnames';
import styles from './index.module.scss';
/**
 * @typedef {"fill" | "sides" | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11} radius
 *
 * @param radius {radius}
 * @returns - [className]
 *
 * @example
 * const [borderRadiusClassName] = getBorderRadius('fill');
 */

var getBorderRadius = function getBorderRadius(radius) {
  var _cx;

  return [cx((_cx = {}, _cx[styles.brFill] = radius === 'fill', _cx[styles.brSides] = radius === 'sides', _cx[styles.br0] = radius === 0, _cx[styles.br1] = radius === 1, _cx[styles.br2] = radius === 2, _cx[styles.br3] = radius === 3, _cx[styles.br4] = radius === 4, _cx[styles.br5] = radius === 5, _cx[styles.br6] = radius === 6, _cx[styles.br7] = radius === 7, _cx[styles.br8] = radius === 8, _cx[styles.br9] = radius === 9, _cx[styles.br10] = radius === 10, _cx[styles.br11] = radius === 11, _cx))];
};

export default getBorderRadius;